import dynamic from "next/dynamic";
import QueryString from "qs";
import Page410 from "../../components/410/410";
import Layout from "../../layout/Layout";
const BlogPage = dynamic(() => import("../../components/pages/BlogPage"));

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

const page410 = [
	"digital-transformation-in-aviation-a-guide-to-choosing-the-best-software-for-your-business",
	"trends-in-digital-transformation-in-higher-education",
	"offshore-software-development",
	"metrics-to-measure-developers-performance",
];

export const getServerSideProps = async (ctx) => {
	const slug = ctx.params.slug;

	// ✅ Properly setting 410 status
	if (page410.includes(slug)) {
		ctx.res.statusCode = 410;
		return {
			props: {
				apiResData: {},
				slug,
				status: 410,
			},
		};
	}

	if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
		ctx.res.setHeader(
			"Cache-Control",
			"public, s-maxage=18000, stale-while-revalidate=59",
		);
	}

	let apiRes = null;
	let apiResData = null;
	let isNew = false;
	const query = QueryString.stringify(
		{
			filters: {
				slug: {
					$eq: slug,
				},
			},
			populate: "deep, 6",
		},
		{
			encodeValuesOnly: false,
		},
	);
	apiRes = await fetch(`${baseUrl}articles?${decodeURIComponent(query)}`);
	apiResData = await apiRes.json();
	isNew = apiResData?.data[0]?.attributes?.design === "new";
	return {
		props: {
			apiResData,
			slug,
			status: 200,
			isNew,
		},
	};
};

// let NewComponent = null;
const BlogDetail = ({ apiResData, slug, status, isNew }) => {
	return (
		<div id="root">
			{/* <Header /> */}
			{status == 410 ? (
				<Page410 />
			) : (
				<div className="">
					<BlogPage slug={slug} data={apiResData} />
				</div>
			)}
			{/* <Troofooter /> */}
		</div>
	);
};
BlogDetail.getLayout = function getLayout(page, props) {

	return (
		<Layout isNew={props.isNew} slug={props.slug}>
			{page}
		</Layout>
	);
};
export default BlogDetail;
